import * as Routes from '../constants/routes';
import { trackingEvent } from '../helpers/tracking';

import Intro from '../calculators/budget-planner/containers/intro';
import StepOne from '../calculators/budget-planner/containers/step-one';
import StepTwo from '../calculators/budget-planner/containers/step-two';
import StepThree from '../calculators/budget-planner/containers/step-three';
import StepFour from '../calculators/budget-planner/containers/step-four';
import StepFive from '../calculators/budget-planner/containers/step-five';
import StepSix from '../calculators/budget-planner/containers/step-six';
import Summary from '../calculators/budget-planner/containers/summary';
import Assessment from '../calculators/budget-planner/containers/assessment';
import ContactEmail from '../calculators/budget-planner/containers/contact-email';
import ContactCoach from '../calculators/budget-planner/containers/contact-coach';
import ThankYouCoach from '../calculators/budget-planner/containers/thank-you-coach';
import ThankYouEmail from '../calculators/budget-planner/containers/thank-you-email';

export const name = 'Budget Planner';

export const inNavigation = true;

export const redirectFromSteps = true;

export const routes = [
    {
        path: Routes.HOME,
        component: Intro,
        pagination: false,
        progressBar: false
    },
    {
        path: Routes.STEPONE,
        component: StepOne,
        pagination: {
            previous: false,
            next: {
                type: 'submit'
            }
        }
    },
    {
        path: Routes.STEPTWO,
        component: StepTwo,
        pagination: {
            next: {
                type: 'submit'
            }
        }
    },
    {
        path: Routes.STEPTHREE,
        component: StepThree,
        pagination: {
            next: {
                type: 'submit'
            }
        }
    },
    {
        path: Routes.STEPFOUR,
        component: StepFour,
        pagination: {
            next: {
                type: 'submit'
            }
        }
    },
    {
        path: Routes.STEPFIVE,
        component: StepFive,
        pagination: {
            next: {
                type: 'submit'
            }
        }
    },
    {
        path: Routes.STEPSIX,
        component: StepSix,
        pagination: {
            next: {
                type: 'submit'
            }
        }
    },
    {
        path: Routes.SUMMARY,
        component: Summary,
        pagination: {
            previous: false,
            next: {
                tracking: () => trackingEvent({
                    eventAction: 'Budget Calculator - Summary',
                    eventLabel: 'Your Summary'
                })
            }
        },
        progressBar: false
    },
    {
        path: Routes.ASSESSMENT,
        component: Assessment,
        pagination: false,
        progressBar: false
    },
    {
        path: Routes.CONTACTCOACH,
        component: ContactCoach,
        pagination: false,
        progressBar: false
    },
    {
        path: Routes.CONTACTEMAIL,
        component: ContactEmail,
        pagination: false,
        progressBar: false
    },
    {
        path: Routes.THANKYOUCOACH,
        component: ThankYouCoach,
        pagination: false,
        progressBar: false
    },
    {
        path: Routes.THANKYOUEMAIL,
        component: ThankYouEmail,
        pagination: false,
        progressBar: false
    }
];
